<template>
  <ui-modal-full-size :title="previewObject.name" :close="close">
    <template #actions="{}">
      <ui-dropdown placement="bottom-end" menu-class="p-3 w-72">
        <template #default="{ toggle }">
          <ui-button-new @click="toggle" primary>
            Actions
            <i class="flex-shrink-0 ml-2 fa fa-chevron-down"></i>
          </ui-button-new>
        </template>

        <template #menu="{ close }">
          <ui-dropdown-item icon="fa fa-arrow-down" :href="previewObject.downloadUrl" target="_blank">Download
          </ui-dropdown-item>
          <ui-dropdown-item @click.prevent="confirmDeletion();" danger icon="fa fa-trash">Delete</ui-dropdown-item>
        </template>
      </ui-dropdown>
    </template>


    <div v-if="previewObject.previewable" class="flex flex-initial overflow-hidden justify-center p-6">
      <img :src="previewObject.previewUrl" class="object-scale-down rounded-sm"/>


    </div>
    <div v-else class="p-2 sm:p-20">
      <div v-if="previewObject.type === 'file'">

        <div class="flex flex-col sm:flex-row gap-8 items-center">

          <i :class="`p-4 text-center text-gray-400 fa fas ${previewObject.icon}`" style="font-size:8rem;"></i>
          <div class="p-0 sm:pr-40">
            <h3 class="text-4xl font-bold mb-4">{{ previewObject.name }}</h3>
            <p class="text-gray-500 text-lg">Created {{ previewObject.createdAt }}</p>
            <p class="text-gray-500 text-lg">by {{ previewObject.createdBy }}</p>
            <p class="text-gray-400 mt-4" v-html="`Filesize: ${previewObject.size}`"></p>
          </div>

        </div>

      </div>
      <div v-else>
        <div class="flex flex-col sm:flex-row gap-8 items-center">

          <i :class="`p-4 text-center text-gray-400 fa fas fa-folder`" style="font-size:8rem;"></i>
          <div class="p-0 sm:pr-40">
            <h3 class="text-4xl font-bold mb-4">{{ previewObject.name }}</h3>
            <p class="text-gray-500 text-lg">Created {{ previewObject.createdAt }}</p>
            <p class="text-gray-500 text-lg">by {{ previewObject.createdBy }}</p>
            <p class="text-gray-400 mt-4">Contains {{ previewObject.size }} objects</p>
          </div>

        </div>
      </div>
    </div>

  </ui-modal-full-size>
</template>

<script>
export default {
  props: {
    previewObject: Object,
    close: Function,
    filesystemId: String,
  },
  data() {
    return {}
  },
  methods: {
    async confirmDeletion() {
      this.$modals.close()
      setTimeout(async () => {
        if (this.previewObject.type === 'file') {
          await this.confirmDeleteFile()
        } else {
          await this.confirmDeleteFolder()
        }
      }, 50)
    },
    async confirmDeleteFile() {
      this.$modals.confirmDelete({
        title: `Delete file "${this.previewObject.name}"`,
        button: 'Yes, delete file',
        handle: async () => {
          await Http.delete(this.previewObject.deleteUrl)
        }
      })
    },
    confirmDeleteFolder() {
      this.$modals.confirmDelete({
        title: `Delete folder "${this.previewObject.name}"`,
        button: 'Delete folder and all sub-files and folders.',
        handle: async () => {
          await Http.delete(this.previewObject.deleteUrl)
        }
      })
    },
  },
}
</script>
